import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { store } from 'redux-rest-reducer';
import { get as getStudentsInfo } from 'actions/students';
import {
  get as getTeacherMappingOptions,
  getAll as getTeacherMapping,
} from 'actions/teacher-mapping';
import { getAll as getPrograms } from 'actions/programs';
import { openModal } from 'actions/modal';

import styled from 'styled-components';
import TeacherList from './teacher-list';
import { FlexView, Separator } from '@cuemath/comps';
import FilterContainer from './filter-container';
import { FORM_ACTIONS, MODAL_FORM } from 'constants/form';
import MODAL from 'constants/modal';
import { EVENT_TYPE } from 'constants/logger';
import { trackEvent } from 'modules/analytics';

const FullFlexView = styled(FlexView)`
  padding: 0 20px;
  overflow: auto;
`;
const programQueryParam = {
  is_live: true,
  board: 'DEMO',
};

export default function TeacherMapping(props) {
  const students = useSelector(store => store.students);
  const programs_store = useSelector(store => store.programs);
  const dispatch = useDispatch();

  const [formValues, setFormValues] = useState({});
  const [studentId, setStudentId] = useState(null);
  const [formattedForm, setFormattedForm] = useState({});

  useEffect(() => {
    async function fetchStudentDetails() {
      const { studentId } = props.match.params;
      await Promise.all([
        dispatch(getStudentsInfo(studentId)),
        dispatch(getPrograms(programQueryParam)),
        dispatch(getTeacherMappingOptions('teacher_mapping_param_options')),
      ]);
      setStudentId(studentId);
    }
    fetchStudentDetails();
  }, []);

  const saveFormValues = (formKey, value) => {
    setFormValues({ ...formValues, [formKey]: value });
  };

  const getTeacherMappingForm = () => {
    const formattedFormData = formattedForm;
    Object.entries(formValues).forEach(([key, value]) => {
      const slotKey = key === 'slot' ? 'slots' : key;
      if (Array.isArray(value)) {
        formattedFormData[slotKey] = value.map(val => val.code);
      } else if (typeof value === 'object') {
        formattedFormData[slotKey] = value && value.code;
      } else {
        formattedFormData[slotKey] = value;
      }
      if (
        !formattedFormData[slotKey] ||
        (formattedFormData[slotKey] && formattedFormData[slotKey].length === 0)
      ) {
        delete formattedFormData[slotKey];
      }
    });
    setFormattedForm(formattedFormData);

    const {
      data: { grade, country_code },
    } = store.get(students, studentId);
    Object.assign(formattedFormData, { grade, country_code, is_plus: true });
    dispatch(getTeacherMapping(formattedFormData));

    const payload = {
      filters: formattedFormData,
      studentId,
    };

    trackEvent(EVENT_TYPE.TEACHER_MAPPING_TEACHERS_SEARCHED, payload);
  };

  const onAssign = (teacherId, teacherName) => {
    const { slot } = formValues || {};
    const { data: programs } = store.getAll(programs_store, programQueryParam);

    const { data: student } = store.get(students, studentId);

    const payload = {
      teacherId,
      studentId,
    };

    trackEvent(EVENT_TYPE.TEACHER_MAPPING_ASSIGN_MODAL_OPENED, payload);

    dispatch(
      openModal(
        MODAL_FORM.ASSIGN_TEACHER,
        {
          size: 'custom',
          width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
          height: MODAL.UPDATE_HEIGHT,
        },
        {
          formType: FORM_ACTIONS.CREATE,
          data: {
            ...student,
            teacherId,
            teacherName,
            scheduled_start_time: slot && slot.code,
          },
          programs,
        },
      ),
    );
  };

  if (studentId) {
    return (
      <FullFlexView justifyContent="center" alignItems="center">
        <Separator transparent height="25" />
        <FilterContainer
          studentId={studentId}
          formValues={formValues}
          setFormValues={saveFormValues}
          getTeacherMappingForm={getTeacherMappingForm}
        ></FilterContainer>
        <Separator transparent height="15" />
        <TeacherList query={formattedForm} onAssign={onAssign} />
      </FullFlexView>
    );
  }

  return null;
}
